var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm._t("default", null, {
    "logo": _vm.logo,
    "backgroundColor": _vm.backgroundColor,
    "primaryColor": _vm.primaryColor,
    "secondaryColor": _vm.secondaryColor,
    "primaryTextColor": _vm.primaryTextColor,
    "splashTextColor": _vm.splashTextColor
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }